import styled from "styled-components";

const ConfirmatioPopupWrapper = styled.section`
  position: relative;
  display: inline-block;

  .confirmation-trigger {
    display: inline-block;
    cursor: pointer;
    outline: none;
  }

  .confirmation-popup {
    position: absolute;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    padding: 10px;
    min-width: 160px;
    z-index: 9999999;
    border-radius: 4px;
    display: grid;
    gap: 4px;
  }

  /* arrow: two-layer (shadow + fill) */
  .confirmation-popup::before,
  .confirmation-popup::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    pointer-events: none;
  }

  .confirmation-popup.top {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
  }

  .confirmation-popup.top::before {
    left: 50%;
    bottom: -9px;
    transform: translateX(-50%);
    border-width: 9px 9px 0 9px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.12) transparent transparent transparent;
  }
  .confirmation-popup.top::after {
    left: 50%;
    bottom: -8px;
    transform: translateX(-50%);
    border-width: 8px 8px 0 8px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }

  .confirmation-popup.bottom {
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 8px;
  }

  .confirmation-popup.bottom::before {
    left: 50%;
    top: -9px;
    transform: translateX(-50%);
    border-width: 0 9px 9px 9px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.12) transparent;
  }
  .confirmation-popup.bottom::after {
    left: 50%;
    top: -8px;
    transform: translateX(-50%);
    border-width: 0 8px 8px 8px;
    border-style: solid;
    border-color: transparent transparent #fff transparent;
  }

  .confirmation-popup.left {
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 8px;
  }

  .confirmation-popup.left::before {
    right: -9px;
    top: 50%;
    transform: translateY(-50%);
    border-width: 9px 0 9px 9px;
    border-style: solid;
    border-color: transparent transparent transparent rgba(0, 0, 0, 0.12);
  }
  .confirmation-popup.left::after {
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    border-width: 8px 0 8px 8px;
    border-style: solid;
    border-color: transparent transparent transparent #fff;
  }

  .confirmation-popup.right {
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 8px;
  }

  .confirmation-popup.right::before {
    left: -9px;
    top: 50%;
    transform: translateY(-50%);
    border-width: 9px 9px 9px 0;
    border-style: solid;
    border-color: transparent rgba(0, 0, 0, 0.12) transparent transparent;
  }
  .confirmation-popup.right::after {
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    border-width: 8px 8px 8px 0;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
  }

  .confirmation-content {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
  }

  .confirmation-actions {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }

  /* .btn {
    padding: 6px 10px;
    border-radius: 3px;
    border: none;
    cursor: pointer;
  } */

  /* .btn-cancel {
    background: transparent;
    color: rgba(0, 0, 0, 0.65);
  }

  .btn-confirm {
    background: var(--primary-brand-color, #1890ff);
    color: #fff;
  } */
`;

export { ConfirmatioPopupWrapper };
